import React from 'react';

import {
  Dropdown,
  Modal,
  ModalActions,
  ModalContent,
  OptionDrop
} from '@stratumn/atomic';

import compose from 'lodash.flowright';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import { Button } from '@/shadcn/button';

import { withUser } from '@/contexts';
import styles from './newLink.style';

export class AnswerGroupDialog extends React.PureComponent {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    groups: PropTypes.array.isRequired,
    selectedGroup: PropTypes.string,
    setSelectedGroup: PropTypes.func.isRequired,
    toggleSignDialog: PropTypes.func.isRequired
  };

  static defaultProps = {
    selectedGroup: null
  };

  render() {
    const {
      open,
      groups,
      selectedGroup,
      setSelectedGroup,
      onClose,
      toggleSignDialog
    } = this.props;

    if (!open) return null;

    const handleChangeGroup = e => {
      setSelectedGroup(e.target.value);
    };

    const handleClose = () => {
      onClose();
      toggleSignDialog();
    };
    return (
      <Modal
        closeButtonLabel="Cancel"
        handleCollapse={onClose}
        title="Select your group"
      >
        <ModalContent>
          You would like to save your answer as a member of:
          <Dropdown
            hideLabel
            label="Your groups"
            onValueChange={handleChangeGroup}
          >
            {groups.map(group => (
              <OptionDrop
                key={group.rowId}
                label={group.name}
                selected={selectedGroup === group.rowId}
                value={group.rowId}
              />
            ))}
          </Dropdown>
        </ModalContent>
        <ModalActions
          adverseAction={
            <Button onClick={onClose} variant="outline">
              Cancel
            </Button>
          }
        >
          <Button
            data-cy="sign"
            disabled={!selectedGroup}
            onClick={handleClose}
          >
            Submit
          </Button>
        </ModalActions>
      </Modal>
    );
  }
}

export default compose(withUser, injectSheet(styles))(AnswerGroupDialog);
